import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { useConfiguration } from "@citrine/resources/configuration";

import * as sx from "./welcome-message.sx";

export function WelcomeMessage() {
  const enablePrivateDocuments = useConfiguration("enablePrivateDocuments");
  return (
    <sx.Container>
      <sx.CatalystIcon />
      <Typography variant="h2">
        <FormattedMessage id="catalyst.welcome.title" />
      </Typography>
      <Typography variant="body2">
        <FormattedMessage
          id={
            enablePrivateDocuments
              ? "catalyst.welcome.body.private-docs"
              : "catalyst.welcome.body"
          }
        />
      </Typography>
    </sx.Container>
  );
}
